<template>
    <div>
        <v-container fluid>
            <v-form ref="form" v-model="valid">
                <v-card
                    class="mx-auto pa-4"
                    max-width="500"
                    outlined
                    >
                    <v-list-item>
                        <v-img max-width="40px" class="mr-4" src="../assets/img/mediatheque_logo.svg"></v-img>
                        <v-list-item-content>
                        <v-list-item-title class="title">Médiathèque</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item monoline>
                        <v-list-item-title >Fournissez votre clé d'API</v-list-item-title>
                    </v-list-item>
                    <v-list-item monoline>
                        <v-text-field :rules="rules" :error-messages="errorKey" label="Clé d'api" v-model="apiToken" hide-details="auto" class="mb-3"></v-text-field>
                    </v-list-item>
                    <v-list-item monoline>
                        <v-btn color="secondary" dark class="mb-4" @click="validateThis">Se Connecter</v-btn>
                    </v-list-item>
                </v-card>
            </v-form>
        </v-container>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    name: 'Login',
    data: () => ({
        valid: false,
        apiToken:"",
        errorKey:"",
        rules: [
            value => !!value || 'Required.',
        ],
    }),
    computed: {
    },
    methods: {
        validateThis() {
            const vm = this;
            axios
                .get("https://api.dev.media.upyourbizz.com/checkkey?key="+this.apiToken)
                .then(function(response){
                    //console.log(response)
                    if(response.data.success === true){
                        vm.$store.dispatch('setKeyIsValid', true)
                        if(vm.$refs.form.validate() && vm.$store.state.keyIsValid){
                            vm.errorKey = "",
                            vm.$store.dispatch('setApiKey', response.data.key)
                            
                            vm.$store.dispatch('initInfosMetas').then((e) => {
                                 let payload = {}
                                payload.from = 0
                                payload.limit = 50
                                vm.$store.dispatch('initArrayMedias', payload).then((e) => {
                                    vm.$router.push({name: "Home"})
                                })
                            })
                        }
                    } else {
                        vm.$store.dispatch('setKeyIsValid', false)
                        vm.errorKey = "La clé fournie n'est pas valide"
                    }
                })
        }
    }
}
</script>